import(/* webpackMode: "eager" */ "/vercel/path0/app/isolierung/page.tsx");
